import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriSubContractStep from '@/models/AgriSubContractStep.js'

export const useAgriSubContractStepStore = defineStore('agriSubContractStepStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_sub_contract_steps'), {
    className: AgriSubContractStep.modelName.name,
    paramKey: AgriSubContractStep.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
